// import Vue from 'vue'
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'


export default (Vue)=>{
  Vue.component("Header", Header)
  Vue.component("Footer", Footer)
}


// WEBPACK FOOTER //
// ./src/loading/loading.js